var _clipPath, _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 64 64",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 31
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    fill: "#bc6904",
    r: 31
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m32 2.1c8 0 15.5 3.1 21.2 8.8s8.7 13.1 8.7 21.1-3.1 15.5-8.8 21.2-13.1 8.7-21.1 8.7-15.5-3.1-21.2-8.8-8.7-13.1-8.7-21.1 3.1-15.5 8.8-21.2 13.1-8.7 21.1-8.7m0-1.1c-17.1 0-31 13.9-31 31s13.9 31 31 31 31-13.9 31-31-13.9-31-31-31z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#a)",
    d: "m51.4 28.1c-5.6 0-11.5-3.8-17.8-7.8-7.4-4.7-15.1-9.6-23.4-9.6v-1.2c8.7 0 16.8 5.2 24 9.8 6.2 3.9 12 7.6 17.2 7.6 2.8 0 4.8-.8 5.8-2.4 2.4-3.5-.3-9.9-.3-10l1.1-.5c.1.3 2.9 7 .2 11.1-1.3 2.1-3.6 3-6.8 3z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#a)",
    d: "m9.4 59.6v-1.2c8.3 0 16-4.9 23.4-9.6 6.3-4 12.3-7.8 17.8-7.8 3.2 0 5.5 1 6.8 2.9 2.7 4.1-.1 10.8-.2 11.1l-1.1-.5c0-.1 2.6-6.4.3-10-1.1-1.6-3-2.4-5.8-2.4-5.2 0-11 3.7-17.2 7.6-7.2 4.7-15.3 9.9-24 9.9z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#a)",
    d: "m32.1 63.6-.2-1.2.1.6-.1-.6s4.9-1 9.8-5c2.8-2.3 5.1-5.1 6.7-8.4 2-4.1 3-9 3-14.4 0-13.4-3.9-21.3-7.1-25.6-4.3-5.4-9.1-7.4-12.3-7.4v-1.2c3.5 0 8.7 2.1 13.2 7.9 6.1 8 7.4 18.7 7.4 26.3 0 5.7-1.1 10.7-3.2 15-1.7 3.5-4.1 6.4-7 8.8-5.1 4.1-10.1 5.2-10.3 5.2z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#a)",
    d: "m40.5 35.4c-9.2 0-22-.7-39.6-2.8l.1-1.2c26.8 3.2 42.1 3 50.2 2.4 8.8-.7 11.3-2.3 11.4-2.3l.7 1c-.2.2-4.6 2.9-22.8 2.9z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m43.3 3.1c1.4 3.5 2.1 7.3 2.1 11.3 0 17.1-13.9 31-31 31-4 0-7.8-.7-11.3-2.1 4.5 11.5 15.8 19.7 28.9 19.7 17.1 0 31-13.9 31-31 0-13.1-8.2-24.4-19.7-28.9z",
    opacity: 0.1
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m49.1 6.1c3.2 4.9 5.1 10.8 5.1 17.1 0 17.1-13.9 31-31 31-6.3 0-12.2-1.9-17.1-5.1 5.6 8.4 15.1 13.9 25.9 13.9 17.1 0 31-13.9 31-31 0-10.8-5.5-20.3-13.9-25.9z",
    opacity: 0.1
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg2);
export default __webpack_public_path__ + "static/media/2.dba1d0314dd24a8a5717c54131d52bf6.svg";
export { ForwardRef as ReactComponent };